import { render, staticRenderFns } from "./Countdowns.vue?vue&type=template&id=68d82116&scoped=true&"
import script from "./Countdowns.vue?vue&type=script&lang=js&"
export * from "./Countdowns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d82116",
  null
  
)

export default component.exports